import React, { useState, useEffect } from 'react'
import { Button } from 'antd'
import AntdTable from '@/components/table/AntdTable'
import { formatMessageNew, downLoadFileBlob, initDateFormat, isChineseFun } from '@/utils/common'
import { getLifecyclePageRfid, exportLifecycleRfid } from '@/services/rfid/rfidSku/rfidSkuReport'

const RFIDSkuModalTable = props => {
  const [tableList, setTableList] = useState([])
  const tableColumns = [
    {
      title: formatMessageNew('languageObj.rfidSkuReport.rfid'),
      dataIndex: 'epc',
      width: 200,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.purchaseOrder'),
      dataIndex: 'purchaseOrder',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.salesOrder'),
      dataIndex: 'salesOrder',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.IBOriginalCartonNumber'),
      dataIndex: 'originalCartonNumber',
      width: 150,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.IBCartonNumber'),
      dataIndex: 'cartonNumber',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.IBTunnelID'),
      dataIndex: 'tunnelId',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.IBCarrier'),
      dataIndex: 'carrier',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.IBItemAttribute'),
      dataIndex: 'itemAttribute',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.IBASN'),
      dataIndex: 'asnNumber',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.IBGRDate'),
      dataIndex: 'grDate',
      width: 100,
      render: text => {
        return <div className="word_break_all">{initDateFormat(text)}</div>
      }
    },

    {
      title:
        formatMessageNew('languageObj.rfidSkuReport.IBTitle') +
        formatMessageNew('languageObj.rfidSkuReport.IBLPNSizeType'),
      dataIndex: 'ibLpnSizeType',
      width: 150,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title:
        formatMessageNew('languageObj.rfidSkuReport.IBTitle') +
        formatMessageNew('languageObj.rfidSkuReport.IBFactoryCode'),
      dataIndex: 'ibFactoryCode',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.deliveryNo'),
      dataIndex: 'deliveryNo',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.OBGIDate'),
      dataIndex: 'giDate',
      width: 100,
      render: text => {
        return <div className="word_break_all">{initDateFormat(text)}</div>
      }
    },
    {
      title:
        formatMessageNew('languageObj.rfidSkuReport.OBTitle') + formatMessageNew('languageObj.rfidSkuReport.OBMajor'),
      dataIndex: 'obMajor',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title:
        formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
        formatMessageNew('languageObj.rfidSkuReport.OBTaskType'),
      dataIndex: 'obTaskType',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title:
        formatMessageNew('languageObj.rfidSkuReport.OBTitle') + formatMessageNew('languageObj.rfidSkuReport.OBSOType'),
      dataIndex: 'obSoType',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title:
        formatMessageNew('languageObj.rfidSkuReport.OBTitle') + formatMessageNew('languageObj.rfidSkuReport.OBRetag'),
      dataIndex: 'obRetag',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title:
        formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
        formatMessageNew('languageObj.rfidSkuReport.OBShipFrom'),
      dataIndex: 'obShipFrom',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title:
        formatMessageNew('languageObj.rfidSkuReport.OBTitle') + formatMessageNew('languageObj.rfidSkuReport.OBShipTo'),
      dataIndex: 'obShipTo',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title:
        formatMessageNew('languageObj.rfidSkuReport.OBTitle') + formatMessageNew('languageObj.rfidSkuReport.OBStore'),
      dataIndex: 'obStore',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title:
        formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
        formatMessageNew('languageObj.rfidSkuReport.OBTrailerNumber'),
      dataIndex: 'obTrailerNumber',
      width: 150,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title:
        formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
        formatMessageNew('languageObj.rfidSkuReport.OBCartonNetWeight'),
      dataIndex: 'obNetWeight',
      width: 150,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title:
        formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
        formatMessageNew('languageObj.rfidSkuReport.OBCartonGrossWeight'),
      dataIndex: 'obGrossWeight',
      width: 150,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.createDate'),
      dataIndex: 'createDate',
      width: 100,
      render: text => {
        return <div className="word_break_all">{initDateFormat(text)}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.updateDate'),
      dataIndex: 'updateDate',
      width: 100,
      render: text => {
        return <div className="word_break_all">{initDateFormat(text)}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.rso'),
      dataIndex: 'rso',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.returnValidation'),
      dataIndex: 'returnValidation',
      width: 150,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.operation'),
      dataIndex: 'operation',
      width: 100,
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.operator'),
      dataIndex: 'operator',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    }
  ]
  useEffect(() => {
    getTableList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectItem.epc])

  const getTableList = () => {
    const params = [props.selectItem.epc]
    getLifecyclePageRfid(params).then(res => {
      const dt = res.resultData
      setTableList(dt)
    })
  }

  const downLoadLifecycleFun = () => {
    let params = [props.selectItem.epc]
    let paramsQuery = {
      ...isChineseFun()
    }
    exportLifecycleRfid(params, paramsQuery).then(res => {
      downLoadFileBlob(res)
    })
  }

  return (
    <AntdTable
      title={() => {
        return (
          <>
            <div style={{ display: 'flex' }}>
              <Button type="primary" onClick={downLoadLifecycleFun}>
                {formatMessageNew('languageObj.commonLocale.download')}
              </Button>
            </div>
            <div className="mt10">
              <div className="mb5">
                <span className="mr5 fwb">{formatMessageNew('languageObj.rfidSkuReport.productCode')}:</span>
                {props.selectItem.productCode}
              </div>
              <div className="mb5">
                <span className="mr5 fwb">{formatMessageNew('languageObj.rfidSkuReport.size')}:</span>
                {props.selectItem.size}
              </div>
              <div className="mb5">
                <span className="mr5 fwb">{formatMessageNew('languageObj.rfidSkuReport.productName')}:</span>
                {props.selectItem.productName}
              </div>
              <div className="mb5">
                <span className="mr5 fwb">{formatMessageNew('languageObj.rfidSkuReport.upc')}:</span>
                {props.selectItem.upc}
              </div>
            </div>
          </>
        )
      }}
      dataSource={tableList}
      columns={tableColumns}
      scroll={{ x: `380%` }}
    />
  )
}
export default RFIDSkuModalTable
